import { translateField } from "@cdv/jazz-i18n";
import { Button, Stack, Typography } from "@mui/material";
import { ReactElement, useContext } from "react";
import AppBar from "../ui/AppBar";
import { Resource } from "../utils";
import { useNavigate } from "react-router";
import { ActionType, AppContext } from "@cdv/jazz-ui";
import { PageContext } from "../App/Context/PageContext";

export default function CardIndex(): ReactElement {
  const navigate = useNavigate();
  const { getUrl } = useContext(AppContext);
  const { tests } = useContext(PageContext);
  return (
    <Stack sx={{ mx: "16px", mb: "70px" }}>
      <AppBar title={translateField(Resource.TestDefinition, "title")} />

      <Stack sx={{ alignItems: "center", mt: "5px" }}>
        <img src="/assets/05_ilustr_test-stres.svg" style={{ maxHeight: "216px" }} />
      </Stack>

      <Typography sx={{ textAlign: "center", mt: "27px", fontSize: "20px" }}>
        Co říká tvůj vnitřní tachometr? <br /> Rychlá STK pro tvoji <br />
        psychickou pohodu.{" "}
      </Typography>

      <Stack spacing={2} sx={{ mt: "28px", alignItems: "center" }}>
        {tests?.map((test) => (
          <Button
            key={test.id}
            size="large"
            variant="contained"
            sx={{ width: "211px" }}
            onClick={() => {
              if (test.versions.length === 1) {
                navigate(
                  getUrl(
                    Resource.TestVersion,
                    ActionType.SHOW,
                    { id: test.versions[0].id },
                    test.id,
                  ),
                );
              } else {
                navigate(getUrl(Resource.TestDefinition, ActionType.SHOW, { id: test.id }));
              }
            }}
          >
            {test.name}
          </Button>
        ))}
      </Stack>
    </Stack>
  );
}
